import * as React from 'react';
import styled from 'styled-components';
import { compose } from '@doltech/utils/lib/compose';
import { withGlobalModalPortal } from '@doltech/ui/lib/hocs/withGlobalModalPortal';
import { GrammarLessonList } from './GrammarLessonList';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import { verticalSpace } from '@doltech/utils/lib/css-style';
import { PaginationPaging } from '@doltech/ui/lib/figma/Pagination/PaginationPaging/PaginationPaging';
import { useRouter } from 'next/router';
import { GrammarUrlByTopicType } from '@doltech/domains/grammar/lib/shared/utils/constants';
import { EmptyLesson } from './EmptyLesson';

const Container = styled.div`
  ${verticalSpace(24)};
  padding: 0 16px;

  .pagination {
    justify-content: flex-end;
  }
`;

interface SectionLessonListingNotAuthorContentProps {
  title?: string;
  initData?: any;
  topicId?: string;
  otherUrlInfo?: any;
  topicUrl?: string;
  currentPageIndex?: number;
}

const SectionLessonListingNotAuthorContent = (props: SectionLessonListingNotAuthorContentProps) => {
  const {
    title,
    initData,
    topicId,
    currentPageIndex,
    otherUrlInfo,
    topicUrl,
  } = props;
  const router = useRouter();

  return (
    <Container className="session-lesson-listing-content">
      <ResponsiveTypography.Paragraph variant="semi-bold/32-40" color="gray180">
        {title}
      </ResponsiveTypography.Paragraph>
      {initData?.content?.length === 0 ? <EmptyLesson/> :
        <GrammarLessonList type="theory" data={initData.content} otherUrlInfo={otherUrlInfo}/>
      }
      {Boolean(initData?.totalPages) && (
        <PaginationPaging
          totalPages={initData.totalPages}
          currentPageIndex={currentPageIndex}
          onChange={(pageIndex) => {
            router.push({
              pathname: topicUrl,
              query: {
                topic: GrammarUrlByTopicType[topicId],
                page: pageIndex + 1,
              },
            });
          }}
          color="purple"
          hideOnSingle
        />
      )}
    </Container>
  );
};

export const SectionLessonListingNotAuthorTheory = compose(withGlobalModalPortal)(SectionLessonListingNotAuthorContent);
